import PropTypes from "prop-types";
import React from "react";
import styles from "../statics/styles/borders-scss.js";
const CellBorders = ({ borders }) => [
  borders?.top && /* @__PURE__ */ React.createElement("div", { key: "top", style: { background: borders.top }, className: styles.borderT }),
  borders?.bottom && /* @__PURE__ */ React.createElement("div", { key: "bottom", style: { background: borders.bottom }, className: styles.borderB }),
  borders?.right && /* @__PURE__ */ React.createElement("div", { key: "right", style: { background: borders.right }, className: styles.borderR }),
  borders?.left && /* @__PURE__ */ React.createElement("div", { key: "left", style: { background: borders.left }, className: styles.borderL })
];
CellBorders.propTypes = {
  borders: PropTypes.object
};
var CellBorders_default = CellBorders;
export {
  CellBorders_default as default
};
//# sourceMappingURL=CellBorders.js.map
